module.exports = __webpack_public_path__ + "static/media/sample_intro_1.6b868f33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home/sample_intro_1.jpg
// module id = 1027
// module chunks = 0